module.exports = __webpack_public_path__ + "static/media/selected.28ffa551.svg";